<template>
    <div class="main">
        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />

        <!-- 主體 -->
        <div class="mainContent">
            
            <!-- 智慧農場 -->
            <div class="agri-result-group pwa pb-1">
                <!-- 條件選單 -->
                <b-container> 
                    <!-- 標題 -->
                    <PwaTitle :textTitle="title" :showMore="false"></PwaTitle>
                    <div class="w3-row" v-show="true">
                        <!-- 小時 -->
                        <div class="w3-col w3-container m4 l4">
                            <p>
                                <label class="global-descript">{{ input.hour.text }}</label>
                                <v-select class="global-descript" v-model="input.hour.value" :options="input.hour.list" :reduce="(option) => option.value" label="text"></v-select>
                            </p>
                        </div>
                        <!-- 颱風 -->
                        <div class="w3-col w3-container m4 l4">
                            <p>
                                <label class="global-descript">{{ input.type.text }}</label>
                                <v-select class="global-descript" v-model="input.type.value" :options="input.type.list" :reduce="(option) => option.value" label="text"></v-select>
                            </p>
                            <div class="global-descript">{{ descript }}</div>
                        </div>
                    </div>
                    <div class="w3-row">
                        <!-- 圖台 -->
                        <div id="map" class="gis-basic">
                            <!-- 圖例說明 -->
                            <div class="legend w3-round-large" style="width: 80px;">
                                <h4 class="legendTitle">圖例說明</h4>
                                <b-container class="bv-example-row mb-3" style="padding-right: 5px;padding-left: 5px;">
                                    <b-row cols="2" style="margin-right: 0px;margin-left: 0px;">

                                        <!-- 風險等級 -->
                                        <b-col class="m-125">
                                            <div class="unit planting-ratio-info red" >
                                                <p class="info">風險等級</p>
                                                <div v-for="(value, key) in openLayers.legend" class="level" :key="'type' + key" style="display: flex;">
                                                    <div>{{ value.value }}</div><div class="color" :style="{background:value.color}" style="width: 15px;height: 20px;margin-left:20px;"></div>
                                                </div>
                                            </div>
                                        </b-col>

                                    </b-row>
                                </b-container>
                            </div>
                        </div>
                        <!-- 訊息視窗 -->
                        <div id="popup" class="ol-popup">
                            <a href="#" id="popup-closer" class="ol-popup-closer" @click="closePopup"></a>
                            <div id="popup-content" v-html="popup.message"></div>
                        </div>   

                    </div>
                           
                </b-container>

            </div> 
        
        </div>

    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
import PwaTitle from '@/components/pwa/PwaTitle.vue'

import Map from 'ol/Map';
import View from 'ol/View';

import { XYZ, 
         Vector as VectorSource, 
        } from "ol/source";
        
import { fromLonLat, 
        } from "ol/proj";

import { Tile,
         Vector as VectorLayer,
        } from "ol/layer";
import GeoJSON from "ol/format/GeoJSON";

import { 
        Fill, 
        Stroke, 
        Style
        } from "ol/style";
import { defaults as defaultControls } from 'ol/control'; 
import Overlay from 'ol/Overlay';
export default {
    created() {
        window.vue = this;
        if(!window.checkLogin()){ window.setPage("login");}               
    },  
    components: {
        Header,
        PwaTitle
    },
    data(){
        return {
            title: "雲林淹水潛勢專區",
            //OpenLayers 相關物件
            //備註:因為地圖物件，會用到很多變數，所以統一，所有的地圖變數都宣告在 openLayers 物件內
            //備註:如果沒有特定的初始值，統一用null以方便外部去做判別
            openLayers:{

                //級距
                legend:[
                    {value:"0",color:"rgba(185, 185, 185, 0.6)"},
                    {value:"1",color:"rgba(43, 143, 0, 0.6)"},
                    {value:"2",color:"rgba(122, 181, 0, 0.6)"},
                    {value:"3",color:"rgba(255, 233, 0, 0.6)"},
                    {value:"4",color:"rgba(249, 117, 0, 0.6)"},
                    {value:"5",color:"rgba(219, 0, 13, 0.6)"}
                ],

                //地圖物件
                Map:null,
                //地圖預設值
                Default:
                {
                    //容器的ID
                    Target:'map',
                    //緯度
                    CenterLat:23.652574754046682,
                    //經度
                    CenterLng:120.36276133502504,
                    //TWD97X
                    TWD97X:184992.53879376827,
                    //TWD97Y
                    TWD97Y:2616692.675353226,
                    //視野(Zoom)
                    Zoom:11,
                },
                //圖層
                Layer:{

                    Tile:{
                        //正射影像圖(通用)
                        PHOTO2:null,
                        //臺灣通用電子地圖(無鐵公路)
                        EMAP9:null,
                        //村里界圖
                        Village:null
                    },
                    //雲林行政區
                    YunlinVill:null,  
                }, 
                //圖層
                Overlay:{

                    //彈出視窗
                    Popup:null,  
                }, 
                //樣式
                Style:{

                    //雲林行政區
                    YunlinVill:function(feature){

                        const _this = window.vue._data;
                        const item = window.vue.map.get(feature.values_.VILLNAME); 
                        var value = -1;
                        var width = 1;
                        var color = "rgba(0, 0, 0, 1)";
                        var fill_color = "rgba(0, 0, 0, 1)";

                        if(_this.openLayers.Select.YunlinVill == feature.values_.VILLNAME)
                        {
                            color = "rgba(255, 0, 0, 1)";
                            width = 3;
                        }
      
                        if (item !== undefined) {

                            if(_this.input.type.value == "E")
                            {
                                value = item.E;
                            }
                            else if(_this.input.type.value == "R")
                            {
                                value = item.R;
                            }
                            else if(_this.input.type.value == "H")
                            {
                                value = item.H;
                            }
                        }

                        switch (Number(value)) {
                            case 0:
                                fill_color = "rgba(185, 185, 185, 0.6)";
                                break;
                            case 1:
                                fill_color = "rgba(43, 143, 0, 0.6)";
                                break;
                            case 2:
                                fill_color = "rgba(122, 181, 0, 0.6)";
                                break;
                            case 3:
                                fill_color = "rgba(255, 233, 0, 0.6)";
                                break;
                            case 4:
                                fill_color = "rgba(249, 117, 0, 0.6)";
                                break;
                            case 5:
                                fill_color = "rgba(219, 0, 13, 0.6)";
                                break;
                            default:
                                fill_color = "rgba(0, 0, 0, 0)";
                        }

                        return new Style({

                            //區塊外框線
                            stroke: new Stroke({
                                //外框線顏色
                                color: color,
                                //外框線寬度
                                width: width
                            }),

                            //區塊樣式
                            fill: new Fill({
                                color: fill_color,
                            }),
                                    
                            //為了讓選擇的圖示，別被其他圖示蓋過，所以zIndex加大
                            zIndex: 11001,   //備註 zIndex 越大會越上層
                        });
                    },
                },
                //目前選擇
                Select:{
                    YunlinVill:null,
                },
                //資料數據
                Data:{
                    YunlinVill:[]
                },
            },

            descript:"",
            data:[],
            list:[],
            map:[],
            //表單物件
            input:{
                //小時
                hour:{
                    text:"小時",
                    value:"1",
                    placeholder:"請選擇小時",
                    list:[
                        {text:"T+1",value:"1"},
                        {text:"T+2",value:"2"},
                        {text:"T+3",value:"3"},
                        {text:"T+4",value:"4"},
                        {text:"T+5",value:"5"},
                    ],
                },
                //種類
                type:{
                    text:"種類",
                    value:"E",
                    placeholder:"請選擇種類",
                    list:[ 
                        {text:"暴露度（Exposure）",value:"E"},
                        {text:"作物綜合風險等級（Risk）",value:"R"},
                        {text:"淹水風險等級（Hazard）",value:"H"}
                    ],
                },
            },

            popup:{
                message:"12346546"
            },

            //api 取得淹水資料
            apiYunlinFlood: (data) => this.userRequest.get("/API/Default/YunlinFlood?H=", data),   
        }
    },
    watch: {

        //小時
        "input.hour.value":function()
        {
            this.setFloodData();
            this.openLayers.Select.YunlinVill = "";
            this.openLayers.Overlay.Popup.setPosition(undefined);
            this.openLayers.Layer.YunlinVill.getSource().changed();     
        },          

        //颱風
        "input.type.value":function()
        {
            this.openLayers.Select.YunlinVill = "";
            this.openLayers.Overlay.Popup.setPosition(undefined);
            this.openLayers.Layer.YunlinVill.getSource().changed();
        },
    },

    mounted() {

        this.initMap();
        this.yunlinFlood();
    },
    methods: {

        //取得資料
        yunlinFlood:function()
        {
            this.apiYunlinFlood({})
            .then((res)=>{

                this.data = [];
                const data = JSON.parse(res.data);
                this.data = data;
                this.setFloodData();
            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });

        },
        //設定資料
        setFloodData:function()
        {
            this.list = [];
            for(var i=0 ; i < this.data.length ; i++)
            {
                var item = this.data[i];
                if(this.input.hour.value == item.H)
                {
                    this.list.push(item);
                }  
            }

            const normalize = s => s.replace(/\s+/g, '').trim();

            this.map = new Map();

            for (let i = 0; i < this.list.length; i++) {
                const item = this.list[i];
                const key = normalize(item.VILL_NAME);
                this.map.set(key, item);
            }
        },
        // 初始(地圖)
        initMap: function () { 

            const _this = this;
            //正射影像圖(通用)
            this.openLayers.Layer.Tile.PHOTO2 = new Tile({
                minZoom: 9,
                maxZoom: 12,
                source: new XYZ({
                    url: "https://wmts.nlsc.gov.tw/wmts/PHOTO2/default/EPSG:3857/{z}/{y}/{x}"
                }),
            });
            //臺灣通用電子地圖(無鐵公路)
            this.openLayers.Layer.Tile.EMAP9 = new Tile({
                minZoom: 9,
                maxZoom: 12,
                source: new XYZ({
                    url: "https//wmts.nlsc.gov.tw/wmts/EMAP/default/EPSG:3857/{z}/{y}/{x}"
                }),
            });
            //村里界圖
            this.openLayers.Layer.Tile.Village = new Tile({
                minZoom: 9,
                maxZoom: 12,
                source: new XYZ({
                    //縣市界
                    //url: "https://wmts.nlsc.gov.tw/wmts/CITY/default/EPSG:3857/{z}/{y}/{x}"
                    //鄉鎮區界
                    //url: "https://wmts.nlsc.gov.tw/wmts/TOWN/default/EPSG:3857/{z}/{y}/{x}"
                    //村里界圖
                    url: "https://wmts.nlsc.gov.tw/wmts/Village/default/EPSG:3857/{z}/{y}/{x}"
                    //地段外圍圖(後期可以考慮這個，這個直接把地段名稱、地段識別碼(範例:奮起段PD0424)秀出來)
                    //url: "https://wmts.nlsc.gov.tw/wmts/LANDSECT/default/EPSG:3857/{z}/{y}/{x}"
                    
                }),
            });
            //彈出視窗
            this.openLayers.Overlay.Popup = new Overlay({
                element: document.getElementById('popup'),
                autoPan: {
                    animation: {
                        duration: 250,
                    },
                },
            });

            //雲林行政區
            this.openLayers.Layer.YunlinVill = this.getStandardVectorPlane({

                style: this.openLayers.Style.YunlinVill,
                source_url: "GeoJSON/yunlin_vill.geojson",
                //source_projection:"EPSG:3826",
                onLoad:function(Param){

                    var mResponseText = Param.XMLHttpRequest.responseText;
                    //若坐標系是TWD97請用這個
                    //var mFeatures = (new GeoJSON()).readFeatures(mResponseText);
                    
                    //若坐標系是經緯度請用這個
                    var mFeatures = (new GeoJSON()).readFeatures(mResponseText,{ featureProjection: Param.Projection });  
                    _this.openLayers.Layer.YunlinVill.getSource().addFeatures(mFeatures);
                }
            });
            this.openLayers.Layer.YunlinVill.set("LayerId", "openLayers.Layer.YunlinVill");
            
            //圖台
            this.openLayers.Map = new Map({
                target: _this.openLayers.Default.Target,
                layers: [
                    //臺灣通用電子地圖(無鐵公路)
                    this.openLayers.Layer.Tile.EMAP9,
                    //村里界圖
                    //this.openLayers.Layer.Tile.Village,
                ],
                overlays: [_this.openLayers.Overlay.Popup],
                view: new View({
                    minZoom: 9,
                    maxZoom: 12,
                    center: fromLonLat([_this.openLayers.Default.CenterLng, _this.openLayers.Default.CenterLat]),
                    zoom: _this.openLayers.Default.Zoom
                }),
                controls: defaultControls({
                    zoom: false // 關閉縮放按鈕
                })
            });

            this.openLayers.Map.addLayer(this.openLayers.Layer.YunlinVill);
            
            /** 註冊監聽事件-當滑鼠單擊時 */
            this.openLayers.Map.on('click', function (e) {

                var pixel = e.pixel;
                var click_event = [];

                //取得所以被觸發的圖層，並將它堆疊再一起
                _this.openLayers.Map.forEachFeatureAtPixel(pixel, function(feature, layer) 
                {
                    click_event.push({feature:feature,layer:layer});
                });

                if(click_event.length > 0) 
                {
                    //僅取第一個被觸發的圖層
                    var mLayer = click_event[0].layer;
                    var mFeature = click_event[0].feature;
                    var mLayerId = mLayer.get("LayerId");

                    switch(mLayerId){

                        case 'openLayers.Layer.YunlinVill':
                        
                            _this.openLayers.Select.YunlinVill = mFeature.values_.VILLNAME;
                            _this.openLayers.Layer.YunlinVill.getSource().changed();
                            console.log(mFeature.values_);

                            var coordinate = e.coordinate;

                            var item = window.vue.map.get(mFeature.values_.VILLNAME); 
                            console.log(item);
                            var value = -1;
                            var fill_color = "rgba(0, 0, 0, 1)";
                            if (item !== undefined) {

                                if(_this.input.type.value == "E")
                                {
                                    value = item.E;
                                }
                                else if(_this.input.type.value == "R")
                                {
                                    value = item.R;
                                }
                                else if(_this.input.type.value == "H")
                                {
                                    value = item.H;
                                }
                            }

                            switch (Number(value)) {
                                case 0:
                                    fill_color = "rgba(185, 185, 185, 0.6)";
                                    break;
                                case 1:
                                    fill_color = "rgba(43, 143, 0, 0.6)";
                                    break;
                                case 2:
                                    fill_color = "rgba(122, 181, 0, 0.6)";
                                    break;
                                case 3:
                                    fill_color = "rgba(255, 233, 0, 0.6)";
                                    break;
                                case 4:
                                    fill_color = "rgba(249, 117, 0, 0.6)";
                                    break;
                                case 5:
                                    fill_color = "rgba(219, 0, 13, 0.6)";
                                    break;
                                default:
                                    fill_color = "rgba(0, 0, 0, 0)";
                            }

                            if(fill_color == "rgba(0, 0, 0, 0)"){ value = "無" }

                            _this.popup.message = mFeature.values_.VILLNAME + '<br /><span class="message">' + '風險等級 : ' + value + '</span><span class="message" style="display: inline-block;width: 15px; height: 15px; margin-left: 5px; background: ' + fill_color + ';"></span>';
                            _this.openLayers.Overlay.Popup.setPosition(coordinate);

                        break;
                    default:
                    } 
                }

            });

            /** 註冊監聽事件-當滑鼠放開時 */
            /*
            this.openLayers.Map.on('moveend', function (e) {

                console.log(e);
                window.vue.valueProcessZOOM = window.vue.openLayers.Map.getView().getZoom();
            });
            */
        },
        //關閉訊息視窗
        closePopup: function(){

            this.openLayers.Select.YunlinVill = "";
            this.openLayers.Overlay.Popup.setPosition(undefined);
            this.openLayers.Layer.YunlinVill.getSource().changed();
            return false;
        },
        //取得圖層-面(實例:GeoJSON)
        getStandardVectorPlane:function(option){

            if(option == undefined || option == null){ option = {};  }

            /** 圖層樣式 */
            if(option.style == undefined || option.style == null){ option.style = null;  }
            /** 資料來源網址 */
            if(option.source_url == undefined || option.source_url == null){ option.source_url = "";  }
            /** 資料來源格式 */
            if(option.source_format == undefined || option.source_format == null){ option.source_format = new GeoJSON();  }
            /** 資料投影 */
            if(option.source_projection == undefined || option.source_projection == null){ option.source_projection = "EPSG:4326";  }


            /** 數據加載時 */
            if(option.onLoad == undefined || option.onLoad == null || typeof(option.onLoad) != 'function')
            {
                option.onLoad = function(aXMLHttpRequest){ console.log(aXMLHttpRequest); }
            }
            /** 程序錯誤時 */
            if(option.onError == undefined || option.onError == null || typeof(option.onError) != 'function')
            {
                option.onError = function(){ alert("加載失敗");  }
            }

            var mVector = new VectorLayer({

                style: option.style,
                source: new VectorSource({

                    format: new GeoJSON(),
                    projection: option.source_projection,
                    loader: function (sourceExtent, resolution, projection) {
                        
                        var mXMLHttpRequest = new XMLHttpRequest();
                        mXMLHttpRequest.open('GET', option.source_url);
                        mXMLHttpRequest.onerror = option.onError;
                        mXMLHttpRequest.onload = function () 
                        {
                            if (mXMLHttpRequest.status == 200) 
                            {
                                var Param = {

                                    XMLHttpRequest:mXMLHttpRequest,
                                    SourceExtent:sourceExtent,
                                    Resolution:resolution,
                                    Projection:projection
                                }

                                option.onLoad(Param);
                            } 
                            else 
                            {
                                option.onError();
                            }
                        }
                        mXMLHttpRequest.send();  
                    }

                })

            });

            return mVector;
        },
    }
}
</script>
<style>

    #map {
        width: 100%;
        height: 70vh;
        min-height: 70vh;
        background: #FFFFFF;
    }

    .table-tr {

        background: #1D976C;
        color: #FFFFFF;
    }

    .table-td-single {

        background: #ecfff8;
        color: #000000;
    } 

    .table-td-double {

        background: #99D0BC;
        color: #000000;
    }

    .ol-popup {
        position: absolute;
        background-color: white;
        box-shadow: 0 1px 4px rgba(0,0,0,0.2);
        padding: 15px;
        border-radius: 10px;
        border: 1px solid #cccccc;
        bottom: 12px;
        left: -50px;
        min-width: 150px;
      }
      .ol-popup:after, .ol-popup:before {
        top: 100%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
      }
      .ol-popup:after {
        border-top-color: white;
        border-width: 10px;
        left: 48px;
        margin-left: -10px;
      }
      .ol-popup:before {
        border-top-color: #cccccc;
        border-width: 11px;
        left: 48px;
        margin-left: -11px;
      }
      .ol-popup-closer {
        text-decoration: none;
        position: absolute;
        top: 2px;
        right: 8px;
      }
      .ol-popup-closer:after {
        content: "✖";
      }

      .ol-popup .message{
        font-size: 0.8em;
      }

</style>